module.exports = __webpack_public_path__ + "img/3e0caba3c97549519c26baa3f733be2a.372b9baf.png";